// extracted by mini-css-extract-plugin
export default {"answers":"BriefAnswers_answers__2Ajiy","answers_click":"BriefAnswers_answers_click__BBOqG"};